import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/notificationConfig/notificationConfig';
import { NotificationConfigView } from './NotificationConfigView';

class NotificationConfig extends Component {
    componentDidMount() {
        this.props.loadConfig();
    }

    render() {
        const { config, loading, updateConfig, toggleNotifications, testNotification } = this.props;
        return (
            <NotificationConfigView
                config={config}
                loading={loading}
                onUpdate={updateConfig}
                onToggle={toggleNotifications}
                onTest={testNotification}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    config: state.notificationConfig.config,
    loading: state.notificationConfig.loading,
});

const mapDispatchToProps = dispatch => {
    return {
        loadConfig: () => dispatch(actions.loadConfig()),
        updateConfig: (data) => dispatch(actions.updateConfig(data)),
        toggleNotifications: () => dispatch(actions.toggleNotifications()),
        testNotification: (data) => dispatch(actions.testNotification(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationConfig);
